import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Routes, RouterModule } from "@angular/router";

import { IonicModule } from "@ionic/angular";

import { DocumentsPage } from "./documents.page";
import { TranslateModule } from "@ngx-translate/core";
import { ComponentModule } from "../../components/component.module";
import { AngularSvgIconModule } from "angular-svg-icon";

const routes: Routes = [
    {
        path: "",
        component: DocumentsPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        TranslateModule,
        ComponentModule,
        AngularSvgIconModule
    ],
    declarations: [DocumentsPage]
})
export class DocumentsPageModule {}
